import React, { useMemo, useState, useEffect } from 'react'
import './popProduct.less'
import Lottie from "react-lottie";
import ConfeteAnimation from "Assets/animations/confetes.json";
import ClockAnimation from "Assets/animations/clock-animation.json";
import { useDispatch, useSelector } from "react-redux";
import {getPopBalloon, postResgate} from 'redux/Reducers/PopBallon/VertemGiftApi';
import PopBalloonFormToUpdateAddress from "./PopBalloonFormToUpdateAddress";
import { useNavigate } from "react-router-dom";
import { usePlaceholderLoading } from "../../PlaceholderLoading";
import { Spin } from '@vertem-core/vertice-ds';


const PopProduct = () => {
    const dispatch = useDispatch();
    const { availableBallons } = useSelector(state => state.VertemGift);
    const Oidc = useSelector(({ oidc }) => oidc);
    const [poppedBallon, setPoppedBallon ] = useState(null);
    const [ isPopingBallonLoading, setIsPopingBallonLoading ] = useState(true)
    const Navigate = useNavigate()
    const { setLoading } = usePlaceholderLoading()
    const defaultOptions = {
        loop: false,
        autoplay: true,
        animationData: ConfeteAnimation,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        },
        width: 400,
        height: 400,
        startFrame: 120
    };

    const getBalloonData = () => {
        if (availableBallons && availableBallons.length > 0) {
            getPopBalloon(availableBallons[0]?.id, Oidc.user).then((response) => {
                setPoppedBallon(response);
            }).finally(() => {
                setIsPopingBallonLoading(false)
            })
        }
    }

    useEffect(() => {
        if (poppedBallon === null && Oidc && Oidc?.user) {
            getBalloonData()
        }
    }, [ poppedBallon, Oidc ])

    const AwardedPrize = () => {
        const [editAddressShowForm, setEditAddressShowForm] = useState(false)
        const getPrize = async (balloonId) => {
            await dispatch(postResgate(balloonId))
            setLoading(false)
            Navigate('/my-orders')
        }

        return (
            <>
                <div className="lottie-container">
                    <Lottie options={defaultOptions} style={{ width: '400px', height: '200px' }} />
                </div>
                {!editAddressShowForm && (<>
                    <img className='banner-congrats' src="https://vertice-ds.s3.amazonaws.com/Assets/Images/Templates/AcessaAgro/BallonAnimation/aniversario/parabens-min.png" alt="Parabéns" />
                    <img className='img-ballon1' src="https://vertice-ds.s3.amazonaws.com/Assets/Images/Templates/AcessaAgro/BallonAnimation/aniversario/balao-m-min.png" alt="Balão" />
                </>)}

                <div className={`container-awarded ${(editAddressShowForm) ? 'animate-show-form' : 'animate-hide-form'}`}>
                    {!editAddressShowForm && (<>
                        <div>
                            <img className='img-awarded' src={poppedBallon?.url} alt="Prêmio" />
                        </div>

                        <span className='awarded'>Você acaba de ganhar:</span>
                        <span className='name-product'> 1 {poppedBallon?.product}</span>

                        <button className='btn-awarded' onClick={() => {
                            setEditAddressShowForm(true)
                        }}>
                            Resgatar o meu prêmio!
                        </button>
                    </>)}

                    {editAddressShowForm && (<>
                        <PopBalloonFormToUpdateAddress
                            callback={() => {
                                getPrize(poppedBallon?.balloonRedemptionId)
                            }}
                            cancel={() => {
                                setEditAddressShowForm(false)
                            }}
                        />
                    </>)}
                </div>

                {!editAddressShowForm && (<>
                    <img className='img-ballon1'
                        src="https://vertice-ds.s3.amazonaws.com/Assets/Images/Templates/AcessaAgro/BallonAnimation/aniversario/balao-m-min.png"
                        alt="Balão" />
                    <img className='img-ballon2'
                        src="https://vertice-ds.s3.amazonaws.com/Assets/Images/Templates/AcessaAgro/BallonAnimation/aniversario/balao-s-min.png"
                        alt="Balão" />
                    <img className='img-ballon3'
                        src="https://vertice-ds.s3.amazonaws.com/Assets/Images/Templates/AcessaAgro/BallonAnimation/aniversario/balao-s-min.png" alt="Balão" />
                </>)}
            </>
        )
    }


    const NotAwardedPrize = () => {
        return (
            <>
                <div className='container-not-awarded'>
                    <img src="https://vertice-ds.s3.amazonaws.com/Assets/Images/Templates/AcessaAgro/BallonAnimation/aniversario/star-icon-min.png" alt="Não foi dessa vez" />
                    <span className='txt-not-awarded'>
                        Não foi desta vez,<br />
                        mas não desanime.
                    </span>

                    <span className='txt-maio-prize'>
                        Todo dia, durante o mês de maio, você<br />
                        tem a chance de ganhar prêmios.<br />
                        Siga resgatando* seus pontos<br />
                        e boa sorte!
                    </span>

                    <span className='txt-rescue-day'>
                        *Limitado a um resgate por dia
                    </span>
                </div>
            </>
        )
    }

    return (
        <div className='product-container'>
            {isPopingBallonLoading &&
                <div>
                    <Lottie options={{
                        loop: true,
                        autoplay: true,
                        animationData: ClockAnimation,
                        width: 100,
                        height: 100
                    }} isClickToPauseDisabled={true} style={{ width: '100px', height: '100px' }} />
                </div>
            }
            {(poppedBallon && poppedBallon?.awarded === false) && (<NotAwardedPrize />)}
            {(poppedBallon && poppedBallon?.awarded !== false) && (<AwardedPrize />)}
        </div>
    )
}

export default PopProduct;
